<template>
  <div class="block my-12">
    <!-- Products list -->
    <div class="">
      <div class="nv-grid-col nv-px-0">
        <h4>
          {{ $t('support_for_home') }}
        </h4>
        <p class="nv-mb-0">
          {{ $t('pick_your_product_or_service') }}
        </p>
      </div>
    </div>

    <div class="">
      <div class="nv-grid-col nv-grid-col-12 nv-px-0">
        <ul class="products-list nv-d-grid nv-my-2">
          <!-- TODO Add dynamic customer category for products and seperate sections for b2c and b2b -->
          <nuxt-link v-for="(prod, pIdx) of data" :key="pIdx" :to="localePath(`/products/b2c/${prod.slug}/kb/about-${prod.slug}?section=getting-started`)" @click="(e: Event) => setProduct(e, prod.slug)">
            <li class="product-card">
              <div class="nv-d-flex">
                <img :src="`${$config.public.NNP_CMS_API_URL}${prod.logo?.url}`" :alt="prod.name">
                <div class="nv-d-flex nv-align-items-center">
                  <strong class="nv-mb-1 text-lg">
                    {{ prod.name }}
                  </strong>
                </div>
              </div>
            </li>
          </nuxt-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { IPayloadCMSProducts } from '~/server/api/support/[region]/types';
import { useProductStore } from '~/store/product';

// ---------------------------------------
// Hooks
// ---------------------------------------

const { t } = useI18n();
const localePath = useLocalePath();
const { $cms } = useNuxtApp();
const productStore = useProductStore();
// -----------------------------------
// Hooks
// -----------------------------------
const { localeProperties } = useI18n();
const {status, error, data } = await useFetch<IPayloadCMSProducts['docs']>(`/api/support/${localeProperties.value.region}/products?language_code=${localeProperties.value.language}`,
  {
    key: `productsGridSupport:${localeProperties.value.code}:${localeProperties.value.language}`,
    lazy: true,
    immediate: true,
  }
);


function setProduct(e: Event, productSlug: string) {
  e.preventDefault();
  const product = data.value?.find((prod) => prod.slug === productSlug)!;

  productStore.set(product);
}

</script>

<style lang="scss" scoped>
/*
* Mixes
*/
@import '@nuiverse/core/src/style/_utils';
@import '@nuiverse/core/src/style/mixins/_breakpoints';

.products-list {
  list-style: none;

  li {
    color: initial;
  }
}

.products-list {
  column-gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  row-gap: 24px;

  li {
    background: var(--nv-theme);
    border-radius: 8px;
    padding: 16px;
    min-width: 240px;

    &:hover {
      box-shadow: 0 0 4px 4px rgba(0, 99, 180, 0.12);
      cursor: pointer;
    }

    img {
      height: 65px;
      margin-right: 8px;
      width: 65px;
    }
  }
}
</style>
